import { render, staticRenderFns } from "./huidige-dienstverlening.vue?vue&type=template&id=703cf9e7&scoped=true"
import script from "./huidige-dienstverlening.vue?vue&type=script&lang=js"
export * from "./huidige-dienstverlening.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703cf9e7",
  null
  
)

export default component.exports